import React from 'react';
import { Gift, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferBlock() {
  const bonuses = [{
    title: 'Guía de Supervivencia en el BBQ',
    value: '$27'
  }, {
    title: 'Rutina Alpha 5 - Metabolismo en 5 min',
    value: '$35'
  }, {
    title: 'Planificador Paso a Paso 14 Días',
    value: '$27'
  }];
  return <section id="oferta" className="bg-dark-bg text-white py-24 px-4 md:px-8 border-t border-dark-surface" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <div className="text-center mb-12" data-id="element-63">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold mb-6 uppercase" data-id="element-64">
            Recuperá el control de tu cuerpo{' '}
            <span className="text-brand-orange" data-id="element-65">hoy mismo</span>
          </h2>
          <p className="font-inter text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-66">
            No esperes al lunes, ni al mes que viene, ni a que la ropa te deje
            de entrar definitivamente.
          </p>
        </div>

        <div className="bg-dark-surface rounded-2xl p-8 md:p-12 border-2 border-brand-orange shadow-[0_0_30px_rgba(255,107,53,0.15)] relative" data-id="element-67">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-orange text-white font-oswald font-bold uppercase py-2 px-6 rounded-full text-lg tracking-wider" data-id="element-68">
            Oferta Especial
          </div>

          <div className="text-center mb-10 mt-4" data-id="element-69">
            <h3 className="font-oswald text-3xl font-bold mb-2 uppercase" data-id="element-70">
              Obtené "Cero Panza 14" ahora por solo
            </h3>
            <div className="flex items-center justify-center gap-4 my-4" data-id="element-71">
              <span className="text-3xl md:text-5xl font-oswald font-bold text-gray-500 line-through" data-id="element-72">
                $17
              </span>
              <span className="text-6xl md:text-8xl font-oswald font-bold text-brand-orange drop-shadow-lg" data-id="element-73">
                $6.39
              </span>
              <span className="text-2xl md:text-4xl font-oswald text-gray-400" data-id="element-74">
                USD
              </span>
            </div>
            <div className="inline-block bg-brand-orange/20 border border-brand-orange/40 rounded-full px-4 py-1 mb-3" data-id="element-75">
              <span className="font-oswald text-brand-orange font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-76">
                🔥 62% de descuento — solo por hoy
              </span>
            </div>
            <p className="font-inter text-gray-400 text-sm md:text-base" data-id="element-77">
              (Un solo pago, acceso de por vida y actualizaciones gratuitas)
            </p>
          </div>

          <div className="bg-dark-bg rounded-xl p-6 md:p-8 mb-10 border border-gray-800" data-id="element-78">
            <h4 className="font-oswald text-2xl font-bold mb-6 text-center uppercase flex items-center justify-center gap-3" data-id="element-79">
              <Gift className="text-brand-orange w-6 h-6" data-id="element-80" />
              Pero espera... si ordenas HOY, te llevas estos 3 Regalos
              (Valorados en $89) Totalmente GRATIS:
            </h4>
            <ul className="space-y-4" data-id="element-81">
              {bonuses.map((bonus, index) => <li key={index} className="flex flex-col md:flex-row md:items-center justify-between border-b border-gray-800 pb-4 last:border-0 last:pb-0" data-id="element-82">
                  <span className="font-inter text-lg text-gray-200 font-medium" data-id="element-83">
                    <span className="text-brand-orange font-bold mr-2" data-id="element-84">
                      Bono #{index + 1}:
                    </span>
                    {bonus.title}
                  </span>
                  <span className="font-oswald text-gray-500 line-through mt-1 md:mt-0" data-id="element-85">
                    Valor {bonus.value}
                  </span>
                </li>)}
            </ul>
            <div className="text-center mt-8 pt-6 border-t border-gray-800" data-id="element-86">
              <p className="font-oswald text-2xl font-bold uppercase text-brand-orange" data-id="element-87">
                ¡Todo por solo $6.39!
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-88">
            <CTAButton fullWidth className="md:w-3/4 py-5 text-2xl" href="https://pay.hotmart.com/T105939705O" data-id="element-89">
              👉 ¡SÍ, QUIERO ELIMINAR MI PANZA AHORA!
            </CTAButton>
            <p className="font-inter text-gray-500 mt-6 flex items-center justify-center gap-2" data-id="element-90">
              <ShieldCheck className="w-5 h-5" data-id="element-91" /> Pago seguro garantizado.
              Recibís el PDF al instante en tu email.
            </p>
          </div>
        </div>
      </div>
    </section>;
}